/**
 * DownloadModalCtrl
 * Functionality to initiate a download.
 *
 * @author Mark Cremer <mark@firstcoders.co.uk>
 */
angular.module('satv.media')
.controller('DownloadQueueModalCtrl', ['$scope', '$rootScope', 'ZippedDownload', function($scope, $rootScope, ZippedDownload) {
    "use strict";
    ZippedDownload.getQueue(function(resp) {
        $scope.downloads = resp;
    });

    $rootScope.$on('MEDIA_DOWNLOAD_QUEUE_REFRESH', function(e, downloads) {
        $scope.downloads = downloads;
    });
}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/mediaclientbundle/Resources/js/angular/controllers/DownloadQueueModalCtrl.js